module.exports = __webpack_public_path__ + "static/media/TODO SOBRE POSTRES.e8a1e356.jpg";